module.exports = __webpack_public_path__ + "img/Frame 105.844cc090.png";